
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_9ckv7_1rwe5_1",
  "container-override": "awsui_container-override_9ckv7_1rwe5_6",
  "active": "awsui_active_9ckv7_1rwe5_6",
  "header": "awsui_header_9ckv7_1rwe5_28",
  "flexible": "awsui_flexible_9ckv7_1rwe5_34",
  "handle": "awsui_handle_9ckv7_1rwe5_38",
  "refresh": "awsui_refresh_9ckv7_1rwe5_41",
  "header-content": "awsui_header-content_9ckv7_1rwe5_45",
  "settings": "awsui_settings_9ckv7_1rwe5_49",
  "fixed": "awsui_fixed_9ckv7_1rwe5_57",
  "resizer": "awsui_resizer_9ckv7_1rwe5_61"
};
  